import {Button, Modal, ModalContent, ModalFooter, ModalTitle, TextRegular} from '@hm/fundamental'

import {useRiskSurveyTranslation} from '../../hooks'

type ArchiveConfirmModalProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading: boolean
}

export const ArchiveConfirmModal = ({
  open,
  onClose,
  onConfirm,
  isLoading
}: ArchiveConfirmModalProps) => {
  const {t} = useRiskSurveyTranslation()

  return (
    <Modal open={open} onClose={onClose} width="thin" data-cy="archive-confirm-modal">
      <ModalTitle>{t('archive.confirmTitle')}</ModalTitle>
      <ModalContent>
        <TextRegular>{t('archive.confirmMessage')}</TextRegular>
      </ModalContent>
      <ModalFooter>
        <Button variant="tertiary" onClick={onClose} data-cy="archive-cancel-button">
          {t('common.cancel')}
        </Button>
        <Button onClick={onConfirm} disabled={isLoading} data-cy="archive-confirm-button">
          {t('archive.archive')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
